import {
  RouteGetCategories_categoryId_Racks,
  type ResponseGetCategories_categoryId_Racks,
} from "@CommonApi/categories/_categoryId_/racks";
import { useQuery, type QueryClient } from "@tanstack/react-query";
import { API, getRequest } from "src/utils/axios";

const categoryRacksQueryKey = (categoryId: number) => ["categories", categoryId, "racks"] as const;

export const fetchCategoryRacks = async (
  categoryId: number,
  signal?: AbortSignal,
): Promise<ResponseGetCategories_categoryId_Racks> => {
  const { data } = await getRequest<ResponseGetCategories_categoryId_Racks>(
    `${API}${RouteGetCategories_categoryId_Racks}`,
    { params: { categoryId }, signal },
  );
  return data;
};

/** The racks a category's store fixtures hold (rack name, and the stores that have it). */
export const useCategoryRacksQuery = (categoryId: number) =>
  useQuery({
    queryKey: categoryRacksQueryKey(categoryId),
    queryFn: ({ signal }) => fetchCategoryRacks(categoryId, signal),
    retry: false,
    refetchOnWindowFocus: false,
  });

export const invalidateCategoryRacks = (queryClient: QueryClient, categoryId: number) =>
  queryClient.invalidateQueries({ queryKey: categoryRacksQueryKey(categoryId) });
